import { notification } from 'antd'
import { addErrorToModal } from './errors-store'

export const openNotificationWithIcon = (type, description, message?) => {
  if (type === 'error') {
    if (description != null || message != null) {
      addErrorToModal({
        id: Math.random(),
        original: description || message,
      })
    }
  } else {
    notification[type]({
      message: message,
      description: description ?? '',
      duration: 2,
      style: {},
    })
  }
}
